// extracted by mini-css-extract-plugin
export default {"container":"MediaSection_container__FMKa1","header":"MediaSection_header__A2B3t","icon":"MediaSection_icon__OmrkF","content":"MediaSection_content__0p03x"};